import Mail from '@mui/icons-material/Mail';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function MailIcon(props: FixMe) {
  return <Mail {...props} />;
}

export default MailIcon;
